import { render, staticRenderFns } from "./AddressComments.vue?vue&type=template&id=566acb14&scoped=true"
import script from "./AddressComments.vue?vue&type=script&lang=js"
export * from "./AddressComments.vue?vue&type=script&lang=js"
import style0 from "./AddressComments.vue?vue&type=style&index=0&id=566acb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566acb14",
  null
  
)

export default component.exports